<div class="page-body">
  <div class="error-wrapper">
    <div class="contents-container">
      <p class="error-message">{{ errorMessage }}</p>
      <p *ngIf="infoMessage" class="info-message">{{ infoMessage }}</p>
    </div>
  </div>
</div>
